









































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ILanguageItem } from "@/interface";
import { ConfigModule, MaskModule } from "@/store/index";
import { getGameAssets } from "@/api/index";

@Component({})
export default class Header extends Vue {
  /* -------------- data ------------- */
  langNavShow = false; // 语言列表是否显示
  selectRegion = ""; // 选中的地区
  searchCountry = ""; // 查询的国家
  displayLangList: ILanguageItem[] = []; // 展示的国家语言列表

  /* -------------- watch ------------- */
  @Watch("langSeled")
  onChangeLangSeled (val: ILanguageItem) {
    ConfigModule.setLangSeled(val);
    this.selectRegion = val.region_of_language;
  }

  @Watch("langNavShow")
  onChangeLangNavShow (val: boolean) {
    if (!val) {
      this.searchCountry = "";
      this.selectRegion = this.langSeled.region_of_language;
    }
  }

  /* -------------- computed ------------- */

  get langList () {
    // 语言国家列表信息
    return ConfigModule.langList;
  }

  get formatRegionLangList () {
    // 格式化 语言列表 （按照地区来排）
    return ConfigModule.formatRegionLangList;
  }

  get allLangList () {
    return this.formatRegionLangList.reduce((acc, cur) => acc.concat(cur.value), [] as ILanguageItem[]);
  }

  get langSeled () {
    // 选中语言项
    return ConfigModule.langSeled;
  }

  get langFlagSeled () {
    // 选中语言的国旗
    return this.setLangFlag(this.langSeled.lang);
  }

  get langDisplayNameSeled () {
    // 选中语言的显示文本
    if (this.langSeled.lang) {
      return this.langSeled.display_name;
    } else {
      return "";
    }
  }

  get categoryForFailText () {
    return ConfigModule.categoryForFailText;
  }

  /* -------------- hook ------------- */

  /* -------------- methods ------------- */

  clickOutSideEvent () {
    this.langNavShow = false;
  }

  /**
   * @description: 返回国旗素材地址
   * @param {string} lang 语言key值
   * @return: 素材地址
   */

  setLangFlag (lang: string) {
    if (lang) {
      try {
        return require(`@/assets/images/header/lang/${lang}.svg`);
      } catch (error) {
        console.error("[setLangFlag]", error);
        return "";
      }
    } else {
      return "";
    }
  }

  /**
   * @description: 选择语言项
   * @param {languageItem} ILanguageItem 语言项
   * @return: void
   */

  async selectLang (languageItem: ILanguageItem) {
    /* 请求游戏页面内容 */
    const currentRouteName = this.$route.name;
    if (currentRouteName === "Shop") {
      /* 商店页面切换地区前先判断该地区游戏是否开放 */
      // const gameId = this.$route.params.gameId;
      const gameId = "heavenburnsred";
      const getGameAssetsRet: any = await getGameAssets(languageItem.lang, gameId);    // eslint-disable-line
      console.log("[Header]-[getGameAssetsRet]", getGameAssetsRet);
      // 游戏详情信息
      const targetAsset = getGameAssetsRet.payload.data.targetAsset;
      if (Object.keys(targetAsset).length === 0) {
        MaskModule.alertMask(this.categoryForFailText);
      } else {
        ConfigModule.setLangSeled(languageItem);
      }
    } else {
      ConfigModule.setLangSeled(languageItem);
    }
    this.langNavShow = false;
  }

  handleSearchCountry () {
    let countryList;
    if (this.selectRegion) {
      const _item = this.formatRegionLangList.find(item => item.key === this.selectRegion);
      countryList = _item ? _item.value : [];
    } else {
      countryList = this.allLangList;
    }

    if (this.searchCountry) {
      countryList = countryList.filter(item => item.display_name && item.display_name.toLocaleLowerCase().indexOf(this.searchCountry.toLocaleLowerCase()) !== -1);
    }

    this.displayLangList = countryList;
  }

  clickLangselect () {
    !this.langNavShow && this.handleSearchCountry();
    this.langNavShow = !this.langNavShow;
  }

  clickRegion (region: string) {
    this.selectRegion = region;
    this.handleSearchCountry();
  }
}
